"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_slick_1 = tslib_1.__importDefault(require("react-slick"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var icons_1 = require("../icons");
var ConfigProvider_1 = require("../ConfigProvider");
var utils_1 = require("../utils");
function Carousel(props) {
    var _a = props.size, size = _a === void 0 ? 'default' : _a, _b = props.type, type = _b === void 0 ? 'default' : _b, _c = props.autoplay, autoplay = _c === void 0 ? false : _c, _d = props.autoplaySpeed, autoplaySpeed = _d === void 0 ? 2000 : _d, beforeChange = props.beforeChange, afterChange = props.afterChange, children = props.children, rootHtmlProps = props.rootHtmlProps;
    var prefix = ConfigProvider_1.usePrefix('carousel');
    var typePrefix = utils_1.concat(prefix, type);
    var sizePrefix = utils_1.concat(typePrefix, size);
    var className = classnames_1.default(prefix, typePrefix, sizePrefix, rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.className);
    var dotsClass = classnames_1.default('slick-dots slick-dots-bottom', typePrefix, sizePrefix);
    var newProps = {
        arrows: false,
        autoplay: autoplay,
        autoplaySpeed: autoplaySpeed,
        cssEase: 'linear',
        infinite: true,
        speed: 300,
        draggable: false,
        dotsClass: dotsClass,
        beforeChange: beforeChange,
        afterChange: afterChange,
        nextArrow: react_1.default.createElement(SlickArrow, { className: sizePrefix },
            react_1.default.createElement(icons_1.RightIcon, null)),
        prevArrow: react_1.default.createElement(SlickArrow, { className: sizePrefix },
            react_1.default.createElement(icons_1.LeftIcon, null))
    };
    if (type === 'secondary') {
        newProps.arrows = true;
    }
    return (react_1.default.createElement("div", tslib_1.__assign({}, rootHtmlProps, { className: className }),
        react_1.default.createElement(react_slick_1.default, tslib_1.__assign({ arrows: false, dots: true }, newProps), children)));
}
exports.default = Carousel;
// 去掉多余的属性，不然控制台有 warning
function SlickArrow(_a) {
    var currentSlide = _a.currentSlide, slideCount = _a.slideCount, children = _a.children, style = _a.style, props = tslib_1.__rest(_a, ["currentSlide", "slideCount", "children", "style"]);
    var centerStyle = { display: 'flex', alignItems: 'center', justifyContent: 'center' };
    return react_1.default.createElement("div", tslib_1.__assign({ style: tslib_1.__assign(tslib_1.__assign({}, style), centerStyle) }, props), children);
}
//# sourceMappingURL=index.js.map